"use client";
import { hometestimonials, testimonials } from "@/data/testimonials";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Image from "next/image";
import Link from "next/link";
export default function AttendanceMainFeatures() {
  return (
    <div className="container position-relative">
      <div className="pt-80 pb-80 pt-sm-70 pb-sm-70 px-4 bg-gray-light-1">
        <div className="row">
          <div className="col-lg-12 -offset-lg-1 wow fadeInUp">
            <div className="row">
              <div className="col-md-10 offset-md-1 text-center">
                <h2 className="section-title mb-70 mb-sm-40">
                  {/* GetBiz Solutions is trusted by &nbsp;
                  <span className="mark-decoration-1">10,000+</span>
                  &nbsp;customers. */}
                  Key Highlights of Our Attendance Management System
                </h2>
              </div>
            </div>
            <div className="overflow-hidden">
              <Swiper
                rewind
                spaceBetween={0}
                slidesPerView={1}
                modules={[Navigation]}
                navigation={{
                  prevEl: ".snbp2",
                  nextEl: ".snbn2",
                }}
                watchSlidesProgress
                resizeObserver
                style={{
                  opacity: 1,
                  display: "block",
                }}
                className="testimonials-slider-1 owl-carousel owl-theme pb-xs-80 overflow-visible position-static"
              >
                {/* {hometestimonials.map((testimonial, index) => (
                  <SwiperSlide className="owl-item" key={index}>
                    <div>
                      <blockquote className="mb-0">
                        <div className="blockquote-icon" aria-hidden="true">
                          ”
                        </div>
                        <p>{testimonial.quote}</p>
                        <div className="section-line mt-40" />
                        <footer className="ts1-author mt-20 clearfix">
                          <div className="overflow-hidden">
                            {testimonial.author}
                            <div className="small">{testimonial.role}</div>
                          </div>
                        </footer>
                      </blockquote>
                    </div>
                  </SwiperSlide>
                ))} */}
                <SwiperSlide className="owl-item" >
                  <div className="row wow pb-80 nmt-80" data-wow-delay="0.5s">
                    <div className="col-lg-6 col-xl-5 d-flex justify-content-center align-items-center">
                      {/* Image */}
                      <div className="position-relative overflow-hidden">
                        <Image
                          width={960}
                          height={539}
                          src="/assets/images/img/product/hrms/attendancems/real-time_attendance_tracking_image.webp"
                          className="image-fullwidth relative"
                          alt="real_time_attendance_tracking_highlight_features"
                        />
                      </div>
                      {/* End Image */}

                    </div>
                    <div className="col-lg-6 mb-md-60 offset-xl-1 d-flex justify-content-center align-items-center">
                      <div className="position-relative">
                        <div className="text-center text-lg-start">

                          <Link href="/hrms-software/attendance-management-system/real-time-attendance-tracking" >
                            <h3 className="h3">Real-Time Attendance Tracking</h3>
                          </Link>

                          <p className="text-gray">
                            Ensure accurate tracking of employee attendance with real-time data synced from biometric devices and attendance systems.
                          </p>
                          <div className="row py-3">
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Biometric device integration
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Real-time updates
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Remote access
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Late punch notifications
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </SwiperSlide>
                <SwiperSlide className="owl-item" >
                  <div className="row wow pb-80 nmt-80" data-wow-delay="0.5s">
                    <div className="col-lg-6 col-xl-5 d-flex justify-content-center align-items-center">
                      {/* Image */}
                      <div className="position-relative overflow-hidden">
                        <Image
                          width={960}
                          height={539}
                          src="/assets/images/img/product/hrms/attendancems/absence_management_image.webp"
                          className="image-fullwidth relative"
                          alt="absence_management_highlight_features"
                        />
                      </div>
                      {/* End Image */}

                    </div>
                    <div className="col-lg-6 mb-md-60 offset-xl-1 d-flex justify-content-center align-items-center">
                      <div className="position-relative">
                        <div className="text-center text-lg-start">
                          <Link href="/hrms-software/attendance-management-system/absence-management" >
                            <h3 className="h3">Absence Management</h3>
                          </Link>

                          <p className="text-gray">
                            Streamline your absenteeism tracking process with automated leave policies and approval workflows.
                          </p>
                          <div className="row py-3">
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Customizable leave policies
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Automated absentee alerts
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Integrated leave system
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Absenteeism reports
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </SwiperSlide>
                <SwiperSlide className="owl-item" >
                  <div className="row wow pb-80 nmt-80" data-wow-delay="0.5s">
                    <div className="col-lg-6 col-xl-5 d-flex justify-content-center align-items-center">
                      {/* Image */}
                      <div className="position-relative overflow-hidden">
                        <Image
                          width={960}
                          height={539}
                          src="/assets/images/img/product/hrms/attendancems/overtime_monitoring_image.webp"
                          className="image-fullwidth relative"
                          alt="overtime_monitoring_highlight_features"
                        />
                      </div>
                      {/* End Image */}

                    </div>
                    <div className="col-lg-6 mb-md-60 offset-xl-1 d-flex justify-content-center align-items-center">
                      <div className="position-relative">
                        <div className="text-center text-lg-start">
                          <Link href="/hrms-software/attendance-management-system/overtime-monitoring" >
                            <h3 className="h3">Overtime Monitoring</h3>
                          </Link>

                          <p className="text-gray">
                            Effortlessly monitor overtime and ensure compliance with company rules, avoiding payroll discrepancies.
                          </p>
                          <div className="row py-3">
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Configurable overtime rules
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Auto overtime calculation
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Custom payroll reports
                              </div>
                            </div>
                            <div
                              className="col-sm-6 col-lg-12 col-xl-6 d-flex py-1"
                            >
                              <div className="features-list-icon">
                                <i className="mi-check" />
                              </div>
                              <div className=" text-sm">
                                Overtime alert notifications
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </SwiperSlide>


                <div className="owl-controls clickable">
                  {/* <div className="owl-pagination">
                    <div className="owl-page">
                      <span className=""></span>
                    </div>
                    <div className="owl-page active">
                      <span className=""></span>
                    </div>
                  </div> */}
                  {/* owl-buttons */}
                  <div className=" text-center">
                    <div className="owl-prev snbp2" role="button" tabIndex="0">
                      <span className="visually-hidden">Previous Slide</span>
                      <i className="mi-arrow-left" aria-hidden="true"></i>
                    </div>
                    <div className="owl-next snbn2" role="button" tabIndex="0">
                      <span className="visually-hidden">Next Slide</span>
                      <i className="mi-arrow-right" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
                {/* End Slide Item */}
              </Swiper>{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
